/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import { formatImageUrl, formatMoney } from '_global/js/helpers'
import { getCustomerDiscount } from 'libs/DisplayDiscount'

import {
  search,
  SEARCH_RESULTS,
  ON_SEARCH
} from 'libs/rcmSearchApi'

import { PAGE_COMPONENTS_LOADED } from '_global/js/main'

import './styles.scss'

class SearchResults {
  constructor (element) {
    this.$el = $(element)

    this.pagination = null
    this.querySummary = null
    this.featuredCollections = null
    this.$pageLoadList = this.$el.find('.searchResults-pageLoadList')
    this.$listItemTemplate = $(this.$el.find('.searchResults-cardTemplate').html())
    this.$resultsList = this.$el.find('.searchResults-resultsList')

    this.showSearchResults = this.showSearchResults.bind(this)
    this.renderCard = this.renderCard.bind(this)

    $(document).on(PAGE_COMPONENTS_LOADED, (e) => {
      this.pagination = this.$el.find('.resultsPagination').data('component')
      this.querySummary = this.$el.find('.querySummary').data('component')
      this.featuredCollections = this.$el.find('.searchResults-featuredCollection .productCarousel').data('component')
      if (this.featuredCollections) {
        this.featuredCollections.initCarousel({
          slickParams: {
            dots: false,
            arrows: true,
            rows: 0, // https://github.com/kenwheeler/slick/issues/3149
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  arrows: false,
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]
          }
        })
      }
    })

    search.on(ON_SEARCH, () => {
      this.$el.addClass('searchResults--isLoading')
      if (this.pagination) {
        this.pagination.setLoading(true)
      }
      this.$el.find('.searchResults-resultSorting select').prop('disabled', true)
    })

    search.on(SEARCH_RESULTS, this.showSearchResults)
  }

  showPageLoadList () {
    this.$pageLoadList.removeClass('u--hide')
  }

  showSearchResults (data) {
    const {
      items,
      totalItems
    } = data

    const {
      q,
      maxPages,
      isFiltered,
      page: currentPage
    } = search

    this.$el.removeClass('searchResults--isLoading searchResults--noResults')
    this.$resultsList.html('')

    if (items && items.length) {
      const cards = items.map(this.renderCard)
      this.$resultsList.append(cards)

      // picturefill for ie11
      if (window.picturefill) {
        window.picturefill()
      }

      if (this.pagination) {
        this.pagination.updatePagination(currentPage, maxPages)
      }
      if (q && this.querySummary) {
        this.querySummary.showQuerySummary(q, totalItems)
      }
    } else {
      this.$el.addClass('searchResults--noResults')
      if (this.pagination) {
        this.pagination.updatePagination(0, 0)
      }
      if (q && this.querySummary) {
        this.querySummary.showQuerySummary(q, 0)
      }
    }

    if (isFiltered || currentPage > 1) {
      this.$el.find('.searchResults-featuredCollection').addClass('u--hide')
    } else {
      this.$el.find('.searchResults-featuredCollection').removeClass('u--hide')
    }
  }

  renderCard (product) {
    const $listItem = this.$listItemTemplate.clone()
    const $productCard = $listItem.find('.productCard')

    // recreate the layout logic as found in _product-card.liquid, and _product-price.liquid
    const {
      title,
      link,
      image_link: featuredImage,
      price,
      list_price: compareAtPrice
    } = product

    const $regularPrice = $productCard.find('[data-regular-price]')
    const $salePrice = $productCard.find('[data-price]')

    let currentPrice = parseFloat(price)
    let strikeoutPrice = parseFloat(compareAtPrice)

    $productCard.find('.productCard-title span').text(title)
    $productCard.find('.productCard-linkWrapper').attr('href', link)

    if (featuredImage) {
      const featuredImageAdjusted = featuredImage.replace('_large', '')
      const $sourceTag = $('<source srcset="" sizes="100" />')
      const imageSrcs = [
        formatImageUrl(featuredImageAdjusted, 'x200'),
        formatImageUrl(featuredImageAdjusted, 'x133')
      ]

      $sourceTag.attr('srcset', imageSrcs.join(','))
      $productCard.find('.productCard-featuredImage').prepend($sourceTag)
    }

    const productDiscount = getCustomerDiscount(product)
    if (productDiscount !== false) {
      if (strikeoutPrice === 0) {
        strikeoutPrice = currentPrice
      }
      currentPrice = productDiscount.finalPrice
    }

    if (strikeoutPrice > 0) {
      $salePrice.html(formatMoney(currentPrice * 100))
      $salePrice.removeClass('u--hide')

      $regularPrice.html(formatMoney(strikeoutPrice * 100, true))
      $regularPrice.addClass('productPrice-price-strikeout')
    } else {
      $salePrice.remove()
      $productCard.find('.productPrice-salePriceText').remove()

      $regularPrice.html(formatMoney(currentPrice * 100))
    }

    $productCard.removeClass('productCard-placeholder')

    return $listItem
  }
}

registerClass('SearchResults', SearchResults)
